export function transformSettings(story: any) {
  return {
    title: story.content.title,
    description: story.content.description,
    menu: story.content.menu.map((item: any) => {
      let href = `/${item.full_slug === 'index' ? '' : item.full_slug}`

      // If href ends with a slash, remove it
      if (href !== '/' && href.endsWith('/')) {
        href = href.slice(0, -1)
      }

      return {
        id: item.id,
        text: item.name === 'Willkommen' ? 'Home' : item.name,
        href,
      }
    }),
  }
}
